import { render, staticRenderFns } from "./activity-edit.vue?vue&type=template&id=ecde3978&scoped=true&"
import script from "./activity-edit.vue?vue&type=script&lang=js&"
export * from "./activity-edit.vue?vue&type=script&lang=js&"
import style0 from "./activity-edit.vue?vue&type=style&index=0&id=ecde3978&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecde3978",
  null
  
)

export default component.exports